import { Box, Typography } from "@mui/material";

import AppButton from "../../../../base/AppButton.component";
import { SendToMobileOutlined } from "@mui/icons-material";
import { ensureAbsoluteUrl } from "../../../../../utils/Utils";
import { useMutation } from "@apollo/client";
import { DEALER_APP_LINK } from "../../../../../graphql/mutation/mutation";
import { useVerification } from "../../../../../context/Verification.context";
import playstore from "../../../../../assets/images/googlePlayStore.png";
import appstore from "../../../../../assets/images/appStore.png";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import TextUnAvailable from "./TextUnAvailable";
import { useState, useEffect } from "react";

const DealerAppResponse = ({ artifact, setDealerAppScreen, isAIDealerApp, onInteraction }) => {
  const verification = useVerification();
  const [activeSuccessMessage, setActiveSuccessMessage] = useState(null);

  useEffect(() => {
    if (activeSuccessMessage) {
      const timer = setTimeout(() => {
        setActiveSuccessMessage(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [activeSuccessMessage]);

  const [dealerAppLink] = useMutation(DEALER_APP_LINK);

  const sendLink = (option, url) => {
    onInteraction?.();

    const newDealerResponse = {
      user_id: parseInt(verification?.customer?.userId),
      dealer_app_id: artifact?.id,
      dealer_review: true,
      created_by: parseInt(verification?.employeeId),
      updated_by: parseInt(verification?.employeeId),
    };

    verification.setArtifactsResponse((prevState) => ({
      ...prevState,
      dealerAppResponse: newDealerResponse,
    }));
    setDealerAppScreen(true);
    if (url) window.open(ensureAbsoluteUrl(url), "_blank");

    if (option) {
      dealerAppLink({
        variables: {
          linkInput: {
            user_id: parseInt(verification?.customer?.userId),
            option: option,
          },
        },
      });
      setActiveSuccessMessage(option);
    }
  };

  const hasMessage = verification.aiData.spanish
    ? !!artifact?.es_message
    : !!artifact?.message;

  return (
    <Box sx={ArtifactStyle.dealerAppOutsideBox}>
      {!isAIDealerApp && (
        <TextUnAvailable
          text={artifact?.message}
          es_text={artifact?.es_message}
        />
      )}

      {/* Render buttons container */}
      {hasMessage && (
        <Box
          sx={{
            display: "flex",
            flexDirection: window.innerWidth <= 750 ? "column" : "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "28px",
          }}
        >
          {/* PlayStore Section */}
          <Box sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            minHeight: activeSuccessMessage === "playstore" ? "140px" : "auto", // Reserve space
            justifyContent: activeSuccessMessage === "playstore" ? "space-between" : "flex-start"
          }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <img
                src={playstore}
                alt="logo"
                onClick={() => sendLink("", artifact?.playstore)}
                style={{ cursor: "pointer", width: 200 }}
              />
              <AppButton
                variant="outlined"
                startIcon={<SendToMobileOutlined />}
                sx={{
                  textTransform: "none",
                  width: window.innerWidth <= 750 ? 200 : "100%",
                  fontWeight: "bold",
                  bgcolor: isAIDealerApp ? "white" : "transparent",
                }}
                buttonText={
                  verification?.aiData?.spanish
                    ? "Enviar al teléfono"
                    : "Send to phone"
                }
                clickHandler={() => {
                  sendLink("playstore");
                }}
              />
            </Box>
            
            {/* PlayStore Success Message - Fixed positioning */}
            <Box sx={{ 
              height: "40px", // Fixed height to reserve space
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "90%"
            }}>
              {activeSuccessMessage === "playstore" && (
                <Typography 
                  variant="body2" 
                  color="#C18803" 
                  bgcolor="#FBF2D6"
                  sx={{ 
                    p: 1,
                    // borderRadius: 1,
                    textAlign: "center",
                    width: "90%",
                    // maxWidth: "200px",
                    animation: "fadeInOut 3s ease-in-out"
                  }}
                >
                  {verification?.aiData?.spanish
                    ? "¡Enviado a tu teléfono!"
                    : "Texted to your phone!"}
                </Typography>
              )}
            </Box>
          </Box>

          {/* AppStore Section */}
          <Box sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            minHeight: activeSuccessMessage === "appstore" ? "140px" : "auto", // Reserve space
            justifyContent: activeSuccessMessage === "appstore" ? "space-between" : "flex-start"
          }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <img
                src={appstore}
                alt="logo"
                onClick={() => sendLink("", artifact?.appstore)}
                style={{ cursor: "pointer", width: 200 }}
              />
              <AppButton
                variant="outlined"
                startIcon={<SendToMobileOutlined />}
                sx={ArtifactStyle.appstoreButtton}
                buttonText={
                  verification?.aiData?.spanish
                    ? "Enviar al teléfono"
                    : "Send to phone"
                }
                clickHandler={() => sendLink("appstore")}
              />
            </Box>
            
            {/* AppStore Success Message - Fixed positioning */}
            <Box sx={{ 
              height: "40px", // Fixed height to reserve space
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "90%"
            }}>
              {activeSuccessMessage === "appstore" && (
                <Typography 
                  variant="body2" 
                  color="#C18803"
                  bgcolor="#FBF2D6"
                  sx={{ 
                    p: 1,
                    // borderRadius: 1,
                    textAlign: "center",
                    width: "90%",
                    // maxWidth: "200px",
                    animation: "fadeInOut 3s ease-in-out"
                  }}
                >
                  {verification?.aiData?.spanish
                    ? "¡Enviado a tu teléfono!"
                    : "Texted to your phone!"}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {/* Add CSS animation for fade in/out */}
      <style jsx>{`
        @keyframes fadeInOut {
          0% {
            opacity: 0;
            transform: translateY(-10px);
          }
          15% {
            opacity: 1;
            transform: translateY(0);
          }
          85% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(-10px);
          }
        }
      `}</style>
    </Box>
  );
};

export default DealerAppResponse;